// Til URL'ning bir qismi bo'lishi uchun markaziy modul.
//
// Sxema: standart til (uz_cyrl) prefikssiz, qolgan ikkitasi prefiksli.
//   /news            -> uz_cyrl   (x-default)
//   /uz-latn/news    -> uz_latn
//   /ru/news         -> ru
//
// Standart til prefikssiz qoldirilgani ataylab: mavjud indekslangan URL'lar,
// bosib chiqarilgan QR kodlar (/qr/*) va OneID'da ro'yxatdan o'tgan
// redirect_uri (/cabinet) o'zgarishsiz ishlashda davom etadi.

export const DEFAULT_LOCALE = "uz_cyrl";

export const LOCALES = {
  uz_cyrl: {
    segment: "", // prefikssiz
    htmlLang: "uz-Cyrl-UZ",
    hreflang: "uz-Cyrl",
    ogLocale: "uz_Cyrl_UZ",
    apiLang: "uz-cyrl",
  },
  uz_latn: {
    segment: "uz-latn",
    htmlLang: "uz-Latn-UZ",
    hreflang: "uz-Latn",
    ogLocale: "uz_Latn_UZ",
    apiLang: "uz-latn",
  },
  ru: {
    segment: "ru",
    htmlLang: "ru-RU",
    hreflang: "ru",
    ogLocale: "ru_RU",
    apiLang: "ru",
  },
};

// Router path'lariga qo'yiladigan ixtiyoriy prefiks. Regex cheklovi bo'lgani
// uchun /news kabi prefikssiz yo'llarni "yutib yubormaydi", /xx/news esa
// umuman mos kelmaydi (404).
export const LANG_PATTERN = "/:lang(ru|uz-latn)?";

const SEGMENTS = Object.keys(LOCALES)
  .map((key) => LOCALES[key].segment)
  .filter(Boolean);

export function localeInfo(locale) {
  return LOCALES[locale] || LOCALES[DEFAULT_LOCALE];
}

// URL segmenti -> i18n locale kaliti ("" yoki noma'lum bo'lsa — standart til)
export function localeFromSegment(segment) {
  if (!segment) return DEFAULT_LOCALE;
  const found = Object.keys(LOCALES).find(
    (key) => LOCALES[key].segment === segment
  );
  return found || DEFAULT_LOCALE;
}

// i18n locale kaliti -> URL segmenti (standart til uchun "")
export function segmentFromLocale(locale) {
  return localeInfo(locale).segment;
}

// Boot vaqtida — router hali ishga tushmagan paytda — pathname'dan tilni
// aniqlash uchun. i18n va axios __lang shu orqali to'g'ri qiymat oladi.
export function localeFromPath(pathname) {
  const first = String(pathname || "").split("/")[1];
  return localeFromSegment(SEGMENTS.indexOf(first) > -1 ? first : "");
}

// fullPath ni path va query/hash qismiga ajratamiz — prefiks bilan ishlaganda
// "/ru?x=1" kabi holatlar noto'g'ri kesilib qolmasligi uchun.
function splitPath(fullPath) {
  const value = String(fullPath == null ? "/" : fullPath) || "/";
  const cut = value.search(/[?#]/);
  return cut === -1
    ? { path: value, suffix: "" }
    : { path: value.slice(0, cut) || "/", suffix: value.slice(cut) };
}

// "/ru/news" -> "/news", "/ru" -> "/", "/ru?x=1" -> "/?x=1"
export function stripLangPrefix(fullPath) {
  const { path, suffix } = splitPath(fullPath);
  for (const segment of SEGMENTS) {
    if (path === "/" + segment) return "/" + suffix;
    if (path.indexOf("/" + segment + "/") === 0) {
      return path.slice(segment.length + 1) + suffix;
    }
  }
  return path + suffix;
}

// "/news" + ru -> "/ru/news"; standart tilda prefikssiz qaytadi
export function withLangPrefix(fullPath, locale) {
  const segment = segmentFromLocale(locale);
  const { path, suffix } = splitPath(stripLangPrefix(fullPath));
  if (!segment) return path + suffix;
  return (path === "/" ? "/" + segment : "/" + segment + path) + suffix;
}
